import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { useSelector } from "react-redux";
import jsPDF from "jspdf";
import "../scss/LGH.scss";
import Table from "react-bootstrap/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";
import moment from "moment";

export default ({ item, icons, icon, data, html }) => {
  const { lang, database, proxy } = useSelector((state) => state);
  const { apiGet } = item;
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const _token = localStorage.getItem("_token");
  const fetchData = () => {
    setLoading(true);
    fetch(`${proxy()}${apiGet.api_detail.url}/${data?.MaPXK}`, {
      headers: {
        Authorization: _token,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        const { success, data } = res;
        if (success && data && data.length > 0) {
          setItems(data);
        }
        handlePDF(data);
      })
      .finally((res) => {
        setLoading(false);
      });
  };

  // useEffect(() => {
  //   if (items && items.length > 0 || data.MaPXK) {
  //     handlePDF();
  //   }
  // }, [items]);

  useEffect(() => {
    let timeout;
    if (loading) {
      Swal.fire({
        title: lang["loading"],
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    } else {
      timeout = setTimeout(() => {
        Swal.close();
      }, 1000);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [loading]);

  const handlePDF = (props) => {
    setLoading(true);
    // const totalSoLuong = props.reduce((total, item) => {
    //   const soLuong = Number(item.SoLuong);
    //   return !isNaN(soLuong) ? total + soLuong : total;
    // }, 0);
    // const totalSoBao = props.reduce((total, item) => {
    //   const soBao = Number(item.SoBao);
    //   return !isNaN(soBao) ? total + soBao : total;
    // }, 0);
    const NgayLapPhieu = moment(data.NgayLapPhieu).format("DD/MM/YYYY");
    const TableView = (
      <div
        className="page container pt-5 pl-5 pr-5 pb-0"
        style={{ width: "210mm" }}
      >
        <header className="d-flex">
          <div className="logo">
            <img src="/images/logo/pvcfclogo.png" alt="logo" width="100px" />
          </div>
          <div className="info">
            <p>
              <strong>
                TỔNG CÔNG TY PHÂN BÓN VÀ HÓA CHẤT DẦU KHÍ - CTCP CHI NHÁNH TỔNG
                CÔNG TY PHÂN BÓN VÀ HÓA CHẤT DẦU KHÍ - CTCP - NHÀ MÁY ĐẠM PHÚ MỸ
              </strong>
            </p>

            <p>Địa chỉ: Khu CN Phú Mỹ 1, Phường Phú Mỹ, Thị xã Phú Mỹ</p>
            <p>
              Điện thoại: (+84) 0254 3 921 468 - Fax: (+84) 0254 3 921 477 -{" "}
              <span>
                Website:{" "}
                <a style={{ color: "black" }} href="https://www.dpm.vn">
                  www.dpm.vn
                </a>
              </span>
            </p>
            <p>
              <strong>Mã số thuế: 0303165480 - 001</strong>
            </p>
          </div>
        </header>
        <hr />
        <div class="info">
          <div className="row">
            <div className="col-sm-4"></div>
            <div className="col-sm-4 first d-flex justify-content-center flex-column align-items-center mb-5">
              <div>
                <h1 className="font-weight-bold">LỆNH GIAO HÀNG</h1>
              </div>
              {/* <div>(Hàng hóa, thành phẩm)</div> */}
              <div>
                Ngày lập phiếu:{" "}
                <span className="font-weight-bold">{NgayLapPhieu}</span>
              </div>
              <div>
                Số: <span className="font-weight-bold">{data.MaLXH}</span>
              </div>
            </div>
            <div className="col-sm-4  second d-flex flex-column align-items-end">
              {/* here */}
              <img
                width={80}
                src={`https://api.qrserver.com/v1/create-qr-code/?data=${data?.MaLXH}`}
                alt="logo"
              />
            </div>
          </div>
          <p>
            Đơn vị mua Hàng: <strong>{data.DonViMuaHang}</strong>
          </p>
          <p>
            Mã khách hàng: <strong>{data.MaKhachHang}</strong>
          </p>
          <p>
            Địa chỉ: <strong>{data.DiaChi}</strong>
          </p>
          <p>
            Mã số thuế: <strong></strong>
          </p>
          <div className="row">
            <div className="col-sm-6">
              <p>
                Điện thoại: <strong>{data.DienThoai}</strong>
              </p>
              <p>
                Yêu cầu: <strong></strong>
              </p>
              <p>
                Hợp đồng: <strong></strong>
              </p>
              <p>Theo phụ lục: </p>
            </div>
            <div className="col-sm-6">
              <p>
                Fax: <strong></strong>
              </p>
              <p>
                Ngày yêu cầu: <strong></strong>
              </p>
              <p>Ngày:</p>
              <p>Ngày:</p>
            </div>
            <div className="col-sm-12">
              <p>
                Phương thức thanh toán: <strong></strong>
              </p>
              <p>
                Phương tiện vận tải: <strong>{data.PhuongTien}</strong>
              </p>
              <p>
                Nhân viên bán hàng: <strong></strong>
              </p>
              <p>
                Đơn vị xuất hàng: <strong>{data.DonViXuatHang}</strong>
              </p>
              <p>Đơn vị vận tải: </p>
              <p>Phương thức giao nhận: </p>
            </div>
          </div>
        </div>
        <table className="mt-3">
          <thead>
            <tr>
              <th>Stt</th>
              <th>
                Tên, nhãn hiệu, quy cách, phẩm chất vật tư, dụng cụ sản phẩm,
                hàng hoá
              </th>
              <th>Mã số</th>
              <th>Chủng loại vỏ bao</th>
              <th>ĐVT</th>
              <th>Số lượng</th>
              <th>Đơn giá</th>
              <th>Thành tiền</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>{data.TenSP}</td>
              <td className="align-center">{data.MaSP}</td>
              <td className="align-center"></td>
              <td className="align-center">Tấn</td>
              <td className="align-center">{data.SoLuongTan}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td className="align-center">Tổng cộng</td>
              <td colSpan={6} className="align-center">
                {data.SoLuongTan}
              </td>
              {/* <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td> */}
            </tr>
          </tbody>
        </table>
        <p className="mt-2">Tổng số tiền (viết bằng chữ): Không đồng</p>
        <footr className="d-flex justify-content-between mt-4">
          <div>
            <strong>Bộ phận Bán hàng</strong>
          </div>
          <div>
            <strong>Bộ phận TCKT</strong>
          </div>
          <div>
            <strong>TUQ. Thủ trưởng đơn vị</strong>
          </div>
        </footr>
      </div>
    );

    const element = document.createElement("div");
    ReactDOM.render(TableView, element);
    const doc = new jsPDF({
      orientation: "p",
      format: "a4",
      unit: "px",
      hotfixes: ["px_scaling"],
    });
    doc.addFont(
      "/fonts/Times New Roman/TIMES.ttf",
      "Times New Roman",
      "normal"
    );
    doc.addFont(
      "/fonts/Times New Roman/TIMESBD.ttf",
      "Times New Roman",
      "bold"
    );
    doc.addFont(
      "/fonts/Times New Roman/TIMESI.ttf",
      "Times New Roman",
      "italic"
    );
    doc.setFont("Times New Roman", "italic");
    doc.setFont("Times New Roman", "normal");
    doc.setFont("Times New Roman", "bold");
    doc.html(element, {
      callback: function (doc) {
        // window.open(doc.output("bloburl"), "_blank");
        setLoading(false);
        doc.save(`${data?.MaLXH}.pdf`);
      },
    });
  };
  const date = new Date();
  const month = date.getUTCMonth() + 1;
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();
  const pMonth = month.toString().padStart(2, "0");
  const pDay = day.toString().padStart(2, "0");
  const renderDate = `Ngày ${pDay} tháng ${pMonth} năm ${year}`;

  return (
    // <TableView />
    <>
      <FontAwesomeIcon
        icon={icons[icon]?.icon}
        title={item?.title ? item?.title : lang["redirect_button"]}
        onClick={handlePDF}
      />
    </>
  );
};
